export default __webpack_public_path__ + "static/media/gallery-2.e05f0e7a.jpg";